/** Flip to `false` to restore legacy Home while Fair sections are built. */
export const USE_FAIR_HOME = true
